"use client";

import { getDistributionDomain } from "@repo/common/cloudfront/env";
import { useEffect, useState } from "react";

export function useCloudFrontUrl(s3Key: string | null | undefined) {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    function run() {
      if (!s3Key) {
        setUrl(null);
        setError(null);
        setIsLoading(false);
        return;
      }
      // Pass through if value is already a URL or data URI or absolute path
      if (
        s3Key.startsWith("http://") ||
        s3Key.startsWith("https://") ||
        s3Key.startsWith("data:") ||
        s3Key.startsWith("/")
      ) {
        setUrl(s3Key);
        setError(null);
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      setError(null);
      try {
        const cdnDomain = getDistributionDomain();
        const computed = `https://${cdnDomain}/${s3Key.replace(/^\/+/, "")}`;
        if (!cancelled) {
          setUrl(computed);
        }
      } catch (e: unknown) {
        if (!cancelled) {
          setError(
            e instanceof Error
              ? e.message
              : "Failed to generate CloudFront URL",
          );
          setUrl(null);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    }
    run();
    return () => {
      cancelled = true;
    };
  }, [s3Key]);

  return { url, isLoading, error };
}
